$(function(){
  // 検収入力時の日付制限チェック: 初回発注承認月 > 検収月 ならエラー
  $('body').on('focus', '.acceptance-amount-input', function (e) {
    const $input = $(this);
    const firstApprovedMonth = $input.data('first-approved-month'); // YYYY-MM形式
    const acceptanceMonth = $input.data('acceptance-month'); // YYYY-MM形式
    const internalOrder = $input.data('internal-order'); // 内部発注はチェック不要

    if (internalOrder) return;

    if (firstApprovedMonth && acceptanceMonth && firstApprovedMonth > acceptanceMonth) {
      alert('発注申請初回承認月（' + firstApprovedMonth + '）より前の月には検収を入力できません。');
      $input.blur();
    }
  });

  $('body').on('change', '.cost-order-form', function (e) {
    const order_form = $(this).val();
    const element_master_id = $(this).attr('id').replace('order_form', 'element_master_id');
    if (order_form) {
        $("#" + element_master_id + " option").attr('disabled', 'disabled');
        let classification = '';
        switch(order_form) {
          case 'material_cost':
            classification = '1';
            break
          case 'labor_cost':
            classification = '2';
            break
          case 'outsourcing_cost':
            classification = '3';
            break
          default:
            classification = '4';
        }
        $("#" + element_master_id).find(".element-master-" + classification).removeAttr("disabled");
    } else {
      $("#" + element_master_id + " option").removeAttr("disabled");
    }
    $("#" + element_master_id).val(null).trigger('change.select2');
  })

  $('.labor_cost_sub_order_fields').on('cocoon:after-insert', function(e, insertedItem) {
    const parent_id = $(this).attr('id');
    const last_month = $("#" + parent_id).attr('data-month');
    const dsp_msg = $("#" + parent_id).attr('data-disabled-msg') || '';
    const checkMonth = window.CheckMonth;
    const last_input = $('#' + parent_id + ' tr:last .sub_acceptance_amount input');
    if (last_input.length === 0) {
      insertedItem.remove();
      alert("行を追加するためには今月までの月を追加し登録するか、施工期間を今月まで延長してください。");
      return;
    }
    const sub_acceptance_name = last_input.attr('name').replace('[0][amount]', '');
    const sub_acceptance_id = last_input.attr('id').replace('0_amount', '');
    const sub_order_index_match = last_input.attr('name').match(/\[sub_orders_attributes\]\[([^\]]+)\]/);
    const sub_acceptance_index = sub_order_index_match ? sub_order_index_match[1] : sub_acceptance_id.match(/\d+/g)[1];
    insertedItem.attr('data-index', sub_acceptance_index);

    if (last_month) {
      let month_index = $('#' + parent_id + ' tr:last .sub_acceptance_amount').length - 1;

      const sub_acceptance_last_month = $('#' + sub_acceptance_id + month_index + '_month').val();
      const diff_month = getMonthDifference(new Date(sub_acceptance_last_month), new Date(last_month));

      let sub_acceptance_last_date = new Date(sub_acceptance_last_month);

      for(let i = 0; i < diff_month; i++) {
        month_index++;
        sub_acceptance_last_date.setMonth(sub_acceptance_last_date.getMonth() + 1);
        let month = '' + parseInt(sub_acceptance_last_date.getFullYear()) + '-' + parseInt(sub_acceptance_last_date.getMonth() + 1) + '-01';

        let sub_acceptance_amount_name = sub_acceptance_name + '[' + month_index + '][amount]';
        let sub_acceptance_amount_id = sub_acceptance_id + month_index + '_amount';
        let sub_acceptance_month_name = sub_acceptance_name + '[' + month_index + '][month]';
        let sub_acceptance_month_id = sub_acceptance_id + month_index + '_month';

        insertedItem.append('<input type="hidden" value="' + month + '" name="' + sub_acceptance_month_name + '" id="' + sub_acceptance_month_id + '">')

        if (checkMonth && checkMonth.appendAmountCells) {
          checkMonth.appendAmountCells({
            $target: insertedItem,
            name: sub_acceptance_amount_name,
            inputId: sub_acceptance_amount_id,
            selected: insertedItem.hasClass('add_color_selected_cell_cost_management'),
            disabledMsg: dsp_msg,
            showButton: !dsp_msg,
            buttonText: '検収',
            extraTd: true
          });
        } else {
          const lockAttr = dsp_msg ? ` readonly onclick='alert(${JSON.stringify(dsp_msg)});this.blur();'` : '';
          const selectedClass = insertedItem.hasClass('add_color_selected_cell_cost_management') ? ' add_color_selected_cell_cost_management' : '';
          const showButton = dsp_msg ? '' : '<div class="ui mini button purchase_order blue" data-notice="sample" data-worker-id="" style="padding: 5px;">検収</div>';
          insertedItem.append(
            `<td><input${lockAttr} class="fuga input-comma-num js-color-fuga${selectedClass}" style="width: 113px;" data-group="" type="text" name="${sub_acceptance_amount_name}" id="${sub_acceptance_amount_id}"></td>` +
            `<td><input type="text" class="fuga js-color-fuga${selectedClass}" style="background: gray; width: 50px;" value="" data-volume="" readonly="">${showButton}</td><td></td>`
          );
        }
      }
    }
  })

  function getMonthDifference(startDate, endDate) {
      return (
          endDate.getMonth() -
          startDate.getMonth() +
          12 * (endDate.getFullYear() - startDate.getFullYear())
      );
  }
})
